import Cookies from 'js-cookie';
import { COOKIES } from '../../config/constants';

var subscribeCache = function subscribeCache() {
  var _window = window,
      ga = _window.ga;

  if (ga) {
    window.ga('send', 'event', 'newsletter', ['subscribe']);
  }

  Cookies.set(COOKIES.SUBSCRIBED, 1, {
    expires: 1000,
    path: '/'
  });
};

export default subscribeCache;